import { useFeatureFlags } from '@/store/featureFlags'

export const isMainBranchStructure = () => {
  const featureFlagsStore = useFeatureFlags()
  return featureFlagsStore.getFeatureFlagByName('main_branch_structure')
}

export const isVetDataManagement = () => {
  const featureFlagsStore = useFeatureFlags()
  return featureFlagsStore.getFeatureFlagByName('vet_data_management')
}

export const isGroupedPetSearchEnabled = () => {
  const featureFlagsStore = useFeatureFlags()
  return featureFlagsStore.getFeatureFlagByName('grouped_pet_search')
}

export const isFarewellClaimsEnabled = () => {
  const featureFlagsStore = useFeatureFlags()
  return featureFlagsStore.getFeatureFlagByName('farewell_claims')
}

export default {
  isMainBranchStructure,
  isVetDataManagement,
  isGroupedPetSearchEnabled,
  isFarewellClaimsEnabled,
}
